<template>
    <Transition name="fade" mode="out-in">
            <DraggableNotes 
            :note="bubblePosition" 
            @update:note="updateBubblePosition" 
            :enabled="props.visible"
            :alwaysOpen="props.alwaysOpen">
                <div 
                    ref="bubbleElement"
                    class="fixed rounded-md px-4 py-2  shadow-lg z-[80] md:z-[80] min-w-[150px] h-12 flex justify-center items-center float-menu" 
                    v-if="props.visible" :style="{top: bubblePosition.y + 'px', left: bubblePosition.x + 'px'}">
                    <Tooltip text="Drag to move" position="bottom" >
                        <button type="button" class="flex flex-row items-center justify-center size-8 float-menu-button px-2 py-1 rounded handle active:cursor-grabbing">
                            <ArrowsPointingOutIcon class="size-6 cursor-grab" />
                        </button>
                    </Tooltip>
                    <div class="border-none border-l h-8 w-px bg-slate-600 ml-4"></div>
                    <Tooltip text="Save" position="bottom" >
                        <button @click="saveEditing" 
                        class="flex flex-row items-center justify-center float-menu-button px-2 py-1 rounded ml-1">
                            <CloudArrowUpIcon class="size-6" />
                        </button>
                    </Tooltip>
                    <Tooltip text="Cancel editing" position="bottom" >
                        <button v-if="!props.alwaysOpen" @click="cancelEditing" class="flex flex-row items-center justify-center float-menu-button px-2 py-1 rounded ml-1">
                            <XMarkIcon class="size-6" />
                        </button>
                    </Tooltip>
                </div>
            </DraggableNotes>
        </Transition>
</template>

<script setup>
import { defineProps, defineEmits, ref, onMounted } from 'vue';
import DraggableNotes from './common/elements/DraggableNotes.vue';
import { CloudArrowUpIcon, XMarkIcon, ArrowsPointingOutIcon } from '@heroicons/vue/24/outline';
import Tooltip from './common/elements/TriadTooltip.vue';

const SONG_EDITOR_FLOATING_MENU_POSITION_KEY = 'song-editor-floating-menu-position';

const props = defineProps({
    visible: {
        type: Boolean,
        required: true
    },
    alwaysOpen: {
        type: Boolean,
        required: false
    }
})

const calculateDefaultPosition = () => {
    const width = 170; // approximate menu width
    const defaultX = Math.max(16, Math.round((window.innerWidth - width) / 2));
    const defaultY = Math.max(16, window.innerHeight - 80);
    return { x: defaultX, y: defaultY };
}

const loadPosition = () => {
    try {
        const saved = localStorage.getItem(SONG_EDITOR_FLOATING_MENU_POSITION_KEY);
        if (saved) {
            const parsed = JSON.parse(saved);
            if (parsed && parsed.x !== undefined && parsed.y !== undefined) {
                return parsed;
            }
        }
    } catch (error) {
        console.error('Error loading song editor floating menu position:', error);
    }
    return calculateDefaultPosition();
}

const savePosition = (pos) => {
    try {
        localStorage.setItem(SONG_EDITOR_FLOATING_MENU_POSITION_KEY, JSON.stringify(pos));
    } catch (error) {
        console.error('Error saving song editor floating menu position:', error);
    }
}

const bubblePosition = ref(loadPosition())

onMounted(() => {
    const saved = localStorage.getItem(SONG_EDITOR_FLOATING_MENU_POSITION_KEY);
    if (!saved) {
        bubblePosition.value = calculateDefaultPosition();
    }
})

const emits = defineEmits(['save', 'cancel'])

const saveEditing = () => {
    emits('save')
}

const cancelEditing = () => {
    emits('cancel')
}

const updateBubblePosition = (updatedNote) => {
    bubblePosition.value = updatedNote
    savePosition(updatedNote)
}
</script>